import { render, staticRenderFns } from "./tournament-news.vue?vue&type=template&id=8598a216&"
import script from "./tournament-news.vue?vue&type=script&lang=js&"
export * from "./tournament-news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports